import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

window.addEventListener('load', () => {
    handleSwiperInit();
});

window.addEventListener('resize', () => {
});

function handleSwiperInit() {
    const blocks = document.querySelectorAll('.testimonials-slider-block');

    blocks.forEach((block) => {
        const container = block.querySelector('.swiper');
        if (!container) return;

        const swiper = new Swiper(container, {
            modules: [Navigation, Pagination],
            spaceBetween: 0,
            slidesPerView: 1,
            navigation: {
                nextEl: block.querySelector('.swiper-button-next'),
                prevEl: block.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: block.querySelector('.swiper-pagination'),
                clickable: true,
            },
        });

        swiper;
    });
}
